import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BeneficiaryListComponent } from './components/beneficiary-list/beneficiary-list.component';

@NgModule({
  declarations: [BeneficiaryListComponent],
  imports: [
    CommonModule
  ],
  exports: [BeneficiaryListComponent]
})
export class BeneficiaryListModule { }
